<script>
  import BaseContentSet from '../BaseContentSet/BaseContentSet.svelte';
  import { getPath } from '../../utils/imageKit.ts';

  let {
    baseContent,
    backgroundImage,
    alignment = 'left',
    lang,
    dataTestId = 'marketing-hero-bleeding-image',
  } = $props();

  // Handle Image Setup
  const moDefaultSrc = getPath(backgroundImage, { w: 275 });
  const moHighResSrc = getPath(backgroundImage, { w: 275 }, 2);
  const smDefaultSrc = getPath(backgroundImage, { w: 426 });
  const smHighResSrc = getPath(backgroundImage, { w: 426 }, 2);
  const lgDefaultSrc = getPath(backgroundImage, { w: 505 });
  const lgHighResSrc = getPath(backgroundImage, { w: 505 }, 2);
</script>

<div data-testid={dataTestId} class="lg:bg-blue-very-light">
  <div
    class="flex flex-col w-full lg:min-h-112 max-w-6xl mx-auto"
    class:lg:flex-row={alignment == 'left'}
    class:lg:flex-row-reverse={alignment == 'right'}
  >
    <div class="bg-blue-very-light lg:w-1/2 xl:w-130 lg:flex lg:items-end">
      {#if backgroundImage && backgroundImage.url && backgroundImage.alt}
        <picture>
          <source media="(min-width: 1024px)" srcset={`${lgDefaultSrc}, ${lgHighResSrc} 2x`} />
          <source media="(min-width: 640px)" srcset={`${smDefaultSrc}, ${smHighResSrc} 2x`} />
          <source media="(max-width: 639px)" srcset={`${moDefaultSrc}, ${moHighResSrc} 2x`} />
          <img class="mx-auto lg:object-contain" src={moDefaultSrc} alt={backgroundImage.alt} />
        </picture>
      {/if}
    </div>
    <BaseContentSet
      {...baseContent}
      lang={lang || 'en'}
      className="p-4 sm:pt-8 sm:pb-0 lg:p-12 w-full lg:w-1/2 xl:w-158"
    />
  </div>
</div>
